import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';

import stepIcon from 'src/public/img/illustration-agreement.svg';

export const ThankYouStep = withTranslation('cbt')(({ t }: WithTranslation) => (
    <S.ContentRow>
        <S.ContentColumn textalign="center">
            <S.StepHeading>{t('week-8.data.heading')}</S.StepHeading>
            <S.StepDescription>{t('week-8.data.congratulationsSneakPeek')}</S.StepDescription>
            <S.StepIcon centered iconUrl={stepIcon} />
        </S.ContentColumn>
    </S.ContentRow>
));
